import { InputAdornment, TextField } from "@mui/material";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import React, { useEffect, useState } from "react";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import UpdateIcon from "@mui/icons-material/Update";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { SCDocumentacionModal } from "../../Dashboard/Clientes/CapturasDashClientes/DocumentadionSC/SCDocumentacionModal";
import { SCDocumentacionModalSinVencimiento } from "../../Dashboard/Clientes/CapturasDashClientes/DocumentadionSC/SCDocumentacionModalSinVencimiento";

import SendIcon from '@mui/icons-material/Send';

export const AnalisarDocumentosOtorgamientoVigencia = ({
    folio,
    setLoader,
    loader,
    // Inyectado por ModalSolicitudCredito (ver ModalSCScreens). Habilita
    // "Siguiente" tras aceptar un documento, sin cerrar el modal.
    habilitarSiguiente,
}) => {
    const [openComentarios, setOpenComentarios] = useState(false);
    const [openJustificacion, setOpenJustificacion] = useState(false);
    const [comentarioID, setComentarioID] = useState(0);
    const [comentarios, setComentarios] = useState("");
    const [doctoselect, setDoctoSelect] = useState({
        iddocumento: "",
        documento: "",
        vencimiento: ""
    });
    const [documentoselect, setDocumentoSelect] = useState({});
    const [accion, setAccion] = useState("");
    const [data, setData] = useState({
        estado: {},
        documentacion: [],
    });

    const onChange = (prop, value, sbool, smensaje) => {
        setComentarios(value);
    };
    useEffect(() => {
        onObtenerAnalisisDocumentacion();
    }, []);
    const onObtenerAnalisisDocumentacion = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ACOtorgamientoCredito/GetMhusa?folio=${folio}`)
            .then((result) => {
                console.table(result.estado);
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    documentacion: result.documentacion,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const OnGetIcon = ({ icon }) => {
        switch (icon) {
            case "wait":
                return <PendingIcon className="wait" />;
            case "success":
                return <CheckCircleIcon className="success" />;
            case "warning":
                return <WarningIcon className="warning" />;
            case "error":
                return <ErrorIcon className="error" />;
            default:
                <></>;
        }
    };
    const onImprimirArchivo = (iddocumento) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
                    iddocumento
                )}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = result.comentarios;
                const downloadLink = document.createElement("a");
                const fileName = `${result.documento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const onEnviarComentario = () => {
        const rescomentarios = ValFormReg(
            "Comentarios",
            comentarios,
            RegularExpressions.TextSpecialCharacter,
            15,
            2000
        );
        if (rescomentarios.isValid === false) {
            Swal.fire(
                "ANALISIS DE SOLICITUD DE CREDITO",
                rescomentarios.mensaje,
                "error"
            );
            return;
        }
        setLoader({ ...loader, mostrar: true });

        const post = {
            folio,
            idproceso: 33,
            iddocumento: doctoselect.iddocumento,
            consecutivo: -1,
            comentarios,
            estatus: accion,
        };

        request
            .post("ACTimelineComentariosTask/EnviarComentarioOtorgamiento", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    documentacion: result.documentacion,
                });
                setComentarios("");
                setOpenComentarios(false);
                setDoctoSelect({
                    iddocumento: "",
                    documento: "",
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };

    const onAceptar = (iddocumento, documento) => {
        setDoctoSelect({ ...doctoselect, documento: documento })
        setOpenJustificacion(!openJustificacion);
        setComentarioID(iddocumento);
    };

    const onAceptar2 = () => {
        const hoy = new Date();
        const fechaVencimiento = new Date(doctoselect.vencimiento);
        if (doctoselect.vencimiento === null || doctoselect.vencimiento === "" || doctoselect.vencimiento === undefined) {
            Swal.fire(
                "ANALISIS DE SOLICITUD DE CREDITO",
                "Favor de agregar una fecha de vencimiento para el documento",
                "error"
            );
            return;
        }
        else if (fechaVencimiento < hoy) {
            Swal.fire(
                "ANALISIS DE SOLICITUD DE CREDITO",
                "La fecha no puede ser anterior a la actual",
                "error"
            );
            return;
        }

        setLoader({ ...loader, mostrar: true });
        setOpenJustificacion(false);
        setComentarios("");
        const post = {
            folio,
            idproceso: 33,
            iddocumento: comentarioID,
            nombreDocumento: doctoselect.documento,
            consecutivo: -1,
            comentarios: comentarios === "" ? "DOCUMENTO APROBADO" : comentarios,
            estatus: "A",
            vencimiento: doctoselect.vencimiento,
        };
        request
            .post("ACTimelineComentariosTask/EnviarComentarioOtorgamientoVencimiento", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    documentacion: result.documentacion,
                });
                setComentarios("");

                setOpenComentarios(false);
                setDoctoSelect({
                    iddocumento: "",
                    documento: "",
                    vencimiento: "",
                });

                // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
                if (habilitarSiguiente !== undefined && habilitarSiguiente !== null)
                    habilitarSiguiente();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };

    const openModal = (documento, iddocumento) => {
        var modal = document.getElementById("modal-documentos");
        modal.style.display = "block";
        setDocumentoSelect({
            documento,
            iddocumento,
        });
    };
    return (
        <div className="analisis-solicitud-credito-proceso">
            <SCDocumentacionModalSinVencimiento
                folio={folio}
                documento={documentoselect.documento}
                iddocumento={documentoselect.iddocumento}
                loader={loader}
                setLoader={setLoader}
                setdocumento={setDocumentoSelect}
                setdocumentos={onObtenerAnalisisDocumentacion}
                cargar={true}
            />
            <div className="analisis-solicitud-credito-proceso-container scroll-4">
                {
                    data.documentacion === undefined ||
                        data.documentacion === null ||
                        data.documentacion.length === 0 ? (
                        <div></div>
                    ) : data.estado.habilitar === true && data.estado.creador === true ? (
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>Documento</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.documentacion.map((doc) => (
                                    <tr>
                                        <td>{doc.documento}</td>
                                        {doc.icono === "success" ? (
                                            <td colSpan={3}>{doc.comentarios}</td>
                                        ) : (
                                            <>
                                                <td>
                                                    {doc.tiene_documentacion === true ? (
                                                        <div
                                                            onClick={() => onImprimirArchivo(doc.iddocumento)}
                                                        >
                                                            <CloudDownloadIcon />
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </td>
                                                <td className="update-documento-analisis">
                                                    <div
                                                        onClick={() =>
                                                            openModal(doc.documento, doc.iddocumento)
                                                        }
                                                    >
                                                        <UpdateIcon />
                                                        Actualizar
                                                    </div>
                                                </td>
                                                {/* <td>
                                                    {doc.tiene_documentacion === true && (
                                                        <div onClick={() => onAceptar(doc.iddocumento)}>
                                                            <CheckCircleIcon />
                                                        </div>
                                                    )}
                                                </td> */}
                                                <td>{doc.comentarios}</td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : data.estado.habilitar === true &&
                        data.estado.creador === false ? (
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>Documento</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.documentacion.map((doc) => (
                                    <tr>
                                        <td>{doc.documento}</td>
                                        {doc.icono === "success" ? (
                                            <td colSpan={3}>{doc.comentarios}</td>
                                        ) : (
                                            <>
                                                <td>
                                                    {doc.tiene_documentacion === true ? (
                                                        <div
                                                            onClick={() => onImprimirArchivo(doc.iddocumento)}
                                                        >
                                                            <CloudDownloadIcon />
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </td>
                                                <td>
                                                    {doc.tiene_documentacion === true && (
                                                        <div onClick={() => onAceptar(doc.iddocumento, doc.documento)}>
                                                            <CheckCircleIcon />
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="update-documento-analisis">
                                                    <div
                                                        onClick={() =>
                                                            openModal(doc.documento, doc.iddocumento)
                                                        }
                                                    >
                                                        <UpdateIcon />
                                                        Actualizar
                                                    </div>
                                                </td>
                                                <td>{doc.comentarios}</td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>Documento</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.documentacion.map((doc) => (
                                    <tr>
                                        <td>{doc.documento}</td>
                                        <td>{doc.comentarios}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )
                }
            </div>
            <div className="analisis-solicitud-credito-proceso-otorgamiento-footer scroll-4">
                {openComentarios && (
                    <TextField
                        fullWidth
                        size="small"
                        label={doctoselect.documento}
                        className="cel-1"
                        multiline
                        rows={3}
                        type="text"
                        // error={condiciones.bcondiciones}
                        onChange={({ target }) => {
                            ValSpecialCharacters(
                                "comentarios",
                                target.value,
                                onChange,
                                true,
                                500
                            );
                        }}
                        value={comentarios}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="start">
                                    <CancelScheduleSendIcon
                                        onClick={() => onEnviarComentario()}
                                    />
                                </InputAdornment>
                            ),
                        }}
                    />
                )}

                {openJustificacion && (
                    <div className="respuesta-documento-container">
                        <TextField
                            className="vencimiento"
                            id="date"
                            label="VENCIMIENTO"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            sx={{ mt: 2 }}
                            // error={state.bvencimiento}
                            onChange={({ target }) =>
                                setDoctoSelect({ ...doctoselect, vencimiento: target.value })
                            }
                            value={doctoselect.vencimiento}
                        />
                        <TextField
                            fullWidth
                            size="small"
                            label={doctoselect.documento}
                            className="w-80"
                            multiline
                            rows={3}
                            type="text"
                            // error={condiciones.bcondiciones}
                            onChange={({ target }) => {
                                ValSpecialCharacters(
                                    "comentarios",
                                    target.value,
                                    onChange,
                                    true,
                                    500
                                );
                            }}
                            value={comentarios}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        <SendIcon className="boton-enviar-aceptar" onClick={() => onAceptar2()} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
